/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RegisterRequest interface.
 */
export function instanceOfRegisterRequest(value) {
    return true;
}
export function RegisterRequestFromJSON(json) {
    return RegisterRequestFromJSONTyped(json, false);
}
export function RegisterRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}
export function RegisterRequestToJSON(json) {
    return RegisterRequestToJSONTyped(json, false);
}
export function RegisterRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'email': value['email'],
        'password': value['password'],
    };
}
